module.exports = "/images/cooper-7.jpg";